
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.984 16.815a4.71 4.71 0 004.706-4.707 4.717 4.717 0 00-4.705-4.707c-.692 0-1.349.151-1.941.421a4.752 4.752 0 00-1.158.749 4.695 4.695 0 00-1.608 3.538 4.712 4.712 0 004.706 4.706zM12 8.631a3.479 3.479 0 110 6.957 3.479 3.479 0 010-6.957zM17.223 9H24v10.278A4.722 4.722 0 0119.278 24H4.785C2.177 24 0 21.886 0 19.278V9h6.747a6.048 6.048 0 00-.872 3.109 6.109 6.109 0 1012.218 0A6.047 6.047 0 0017.223 9zm2.055-9H7v5H6V0H5v5H4V.077a4.79 4.79 0 00-1 .27V5H2V.898c-1.202.857-2 2.246-2 3.824V8h7.473a6.087 6.087 0 019.022 0H24V4.722A4.722 4.722 0 0019.278 0zM22 5.265a.74.74 0 01-.745.735h-2.511A.74.74 0 0118 5.265v-2.53A.74.74 0 0118.744 2h2.511a.74.74 0 01.745.735v2.53z"}})])
          )
        }
      }
    